export var getCommunicationChartLinkTrend = function (stats) {
    var current = stats.weight;
    var previous = stats.previousWeight;
    if (current > 0 && previous === 0) {
        return 'new';
    }
    if (current === 0 && previous > 0) {
        return 'dropped';
    }
    if (current > previous) {
        return 'up';
    }
    if (current < previous) {
        return 'down';
    }
    return 'unchanged';
};
export var getCommunicationChartLinkDisplayWeight = function (stats) { return stats.weight; };
/** Maps link trend to chart line style: channel color solid (up), red solid (down), grey solid (unchanged); dashed channel color for new only. */
export var getCommunicationChartLinkDisplayTrend = function (stats) {
    var trend = getCommunicationChartLinkTrend(stats);
    if (trend === 'new') {
        return 'new';
    }
    if (trend === 'up') {
        return 'up';
    }
    if (trend === 'down') {
        return 'down';
    }
    return 'unchanged';
};
